module.exports = __webpack_public_path__ + "static/media/word-logo-8.d8471ed2.png";